module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 169
// module chunks = 7